export const hasValue = (value) => {
  return value !== null && value !== undefined
}
